// Mock data for frontend-only implementation
// This will be replaced with actual API calls after backend integration

export const mockQuotes = [
  {
    id: '1',
    garageSize: '2-car',
    basePrice: 450,
    heavyItems: true,
    sweeping: true,
    pressureWashing: false,
    totalPrice: 607.5,
    email: 'customer@example.com',
    phone: '555-0123',
    createdAt: new Date().toISOString()
  }
];

export const calculateQuote = (garageSize, services) => {
  const basePrices = {
    '1-car': 209,   // Rounded pricing
    '2-car': 379,   // Rounded pricing
    '3-car': 629    // Rounded pricing
  };

  const basePrice = basePrices[garageSize] || 0;
  let additionalCost = 0;

  if (services.heavyItems) {
    additionalCost += basePrice * 0.25; // 25% for heavy items
  }

  if (services.sweeping) {
    additionalCost += basePrice * 0.05; // 5% for sweeping
  }

  if (services.pressureWashing) {
    additionalCost += basePrice * 0.50; // 50% for pressure washing
  }

  return {
    basePrice,
    additionalCost,
    totalPrice: basePrice + additionalCost
  };
};

export const saveQuoteMock = (quoteData) => {
  // Mock save - stores in browser session storage
  const quotes = JSON.parse(sessionStorage.getItem('quotes') || '[]');
  const newQuote = {
    ...quoteData,
    id: Date.now().toString(),
    createdAt: new Date().toISOString()
  };
  quotes.push(newQuote);
  sessionStorage.setItem('quotes', JSON.stringify(quotes));
  return newQuote;
};